module.exports = __webpack_public_path__ + "img/type-style1.a2e34bbb.png";